import { render } from "./ExplanationModal.vue?vue&type=template&id=67b4675f&scoped=true"
import script from "./ExplanationModal.vue?vue&type=script&lang=js"
export * from "./ExplanationModal.vue?vue&type=script&lang=js"

import "./ExplanationModal.vue?vue&type=style&index=0&id=67b4675f&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b4675f"]])

export default __exports__